import type { CSSProperties } from "react";
import React from "react";

import classNames from "classnames";

import type { DropdownSearchProps } from "../DropdownSearch/DropdownSearch";
import DropdownSearch from "../DropdownSearch/DropdownSearch";

export type DropdownContentProps = {
    open: boolean;
    children: React.ReactNode;
    className?: string;
    dropdownContentStyles?: CSSProperties;
    searchProps?: Omit<DropdownSearchProps, "open" | "className">;
    includesSearch?: boolean;
};

const DropdownContent: React.FC<DropdownContentProps> = ({
    open,
    children,
    searchProps,
    className = null,
    dropdownContentStyles = {},
    includesSearch = false,
}) => {
    return (
        <div
            style={dropdownContentStyles}
            className={classNames(className, { "--closed": !open })}
            data-automation="dropdown-content"
            data-automation-open={open}
        >
            {includesSearch && searchProps ? (
                <DropdownSearch
                    open={open}
                    {...searchProps}
                />
            ) : null}
            {children}
        </div>
    );
};

export default React.memo(DropdownContent);
